import CopyOrder from './CopyOrder';

export default CopyOrder;
